<template>
  <dropdown
    ref="inputDropdown"
    :force-visibility="isOpen"
    :is-disabled="isDisabled"
    title="Saved Templates"
    class="editor-saved-templates__dropdown"
    @open="isOpen = true"
    @close="isOpen = false"
  >
    <div class="editor-saved-templates__button">
      <i class="ddi-description ddi" />
      <i class="ddi-caret-down ddi" />
    </div>

    <template #content>
      <div>
        <ul>
          <li
            v-for="(item, index) in savedTemplates"
            :key="index"
            @click="handleSelect(item)"
          >
            <span :class="{ selected: selectedTemplateId === item.id }">
              {{ item.title }}
            </span>
          </li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { IDescriptionTemplate } from '@/api/types/response.types'

export default defineComponent({
  name: 'EditorSavedTemplates',

  props: {
    savedTemplates: {
      type: Array as () => IDescriptionTemplate[],
      default: Array as () => IDescriptionTemplate[],
    },

    message: {
      type: String,
      default: '',
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['selected-saved-template'],

  data() {
    return {
      isOpen: false,
      selectedTemplateId: null as any,
      selectedTemplateBody: '',
    }
  },

  watch: {
    message: {
      immediate: true,
      handler(value) {
        // remove HTML to compare only the content of the saved reply
        const valueWithoutHTML = value.replace(/<(?!\s*\/?\s*img)[^>]*>/gi, '')
        const selectedWithoutHTML = this.selectedTemplateBody.replace(
          /<(?!\s*\/?\s*img)[^>]*>/gi,
          '',
        )

        if (valueWithoutHTML !== selectedWithoutHTML) {
          this.selectedTemplateBody = ''
          this.selectedTemplateId = null
        }
      },
    },
  },

  methods: {
    handleSelect(item: any) {
      this.selectedTemplateId = item.id
      this.setSelectedReply(item.description)
      this.isOpen = false
    },

    /**
     * Emit event to Editor to apply the saved reply
     */
    setSelectedReply(savedTemplateBody: string) {
      this.selectedTemplateBody = savedTemplateBody
      this.$emit('selected-saved-template', savedTemplateBody)
    },
  },
})
</script>

<style lang="scss" >
.editor-saved-templates {
  &__button {
    display: flex !important;
    align-items: flex-end;
    color: var(--color-text-primary);

    .ddi-description {
      top: -1px;
      font-size: 14px;
    }

    .ddi-caret-down {
      left: 6px;
      top: -2px;
      font-size: 10px;
    }

    &:hover {
      color: $bluish;
    }

    &::before {
      display: inline-block;
      width: 1px;
      height: 16px;
      margin: 0 12px 0 8px;
      vertical-align: text-top;
      content: '';
      background: $color--gray-60;
      border-radius: 3px;
      opacity: 0.56;
    }
  }

  &__dropdown {
    display: flex !important;
    align-items: center;

    .dropdown__popper {
      min-width: 240px;
      max-width: 240px;
    }
  }
}
</style>
